exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-faq-widget[data-v-26a9908d]{max-width:100%}.card-title[data-v-26a9908d]{color:#495057}.card-title i[data-v-26a9908d]{color:#007bff;margin-right:.5rem}.responses-history[data-v-26a9908d]{border-top:1px solid #dee2e6;padding-top:1rem}@media (max-width:768px){.card[data-v-26a9908d]{border-left:none;border-right:none;border-radius:0}}.cursor[data-v-26a9908d]{cursor:pointer;color:#6c757d;font-size:.875rem}.cursor[data-v-26a9908d]:hover{color:#495057}.cursor i[data-v-26a9908d]{margin-right:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26a9908d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/AiAgents/FaqAgent/FaqAgent.vue
// module id = 1963
// module chunks = 1